export default "__VITE_ASSET__CMGCb$j8__"